import { Button } from '@alfa-bank/site-button-v2';
import { Spinner } from '@alfa-bank/site-loader/spinner';
import { Text } from '@alfa-bank/site-text-v2';
import { CountdownTimer } from '@alfa-bank/site-timer/countdown-timer';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { CodeInputDesktop as CodeInput } from '@alfa-bank/site-code-input/desktop';

import { CodeInputField as Component } from '../code-input-field';
import type { IDepsDesktop, TCodeInputFieldDesktop } from '../models';

import styles from './desktop.css';

// eslint-disable-next-line styler/check-styler
export const CodeInputFieldDesktop = createWidget<IDepsDesktop, TCodeInputFieldDesktop>({
    Button,
    CodeInput,
    CountdownTimer,
    Spinner,
    Text,
    styles,
})(Component);
